import { onCheckCondition } from 'designer/component/action/condition/Action'
import {
  getCurrentUi,
  getDefaultValueFromUi,
  getFieldName,
} from 'designer/component/action/Data'
import objectPath from 'object-path'
import Swal from 'sweetalert2'
import { openModal } from './Modal'
import { getFormGroup } from 'designer/component/action/FormGroup'
import cloneDeep from 'clone-deep'
import { getFormGroupResetKeyList } from './ResetFormGroup'
import { cancelDesignerRequests } from 'designer/component/action/RequestTimeout'

export const showAndHide = ({ action, designContext }) => {
  const { updateUiSchema } = designContext
  let { show = [], hide = [] } = action
  show.forEach((item) => {
    if (item?.value) {
      updateUiSchema(item.value, 'isShowUi', true)
    }
  })
  hide.forEach((item) => {
    if (item?.value) {
      updateUiSchema(item.value, 'isShowUi', false)
    }
  })
}

export const onBeforeAlert = (props) => {
  let { action, data, designContext, uischema, setModalAction, setOpenModal } =
    props
  if (action.name === 'alert') {
    onAlert(props, true)
  } else if (action.name === 'openModal') {
    openModal({
      action,
      data,
      designContext,
      uischema,
      setModalAction,
      setOpenModal,
    })
  } else if (action.name === 'callback') {
    callbackFunction({ action, data, designContext })
    let { isUiChanged, setIsUiChanged } = designContext
    objectPath.set(isUiChanged, uischema.key, { doAction: true })
    setIsUiChanged(isUiChanged)
  }
}

export const onAlert = (
  { action, formData, doAction, designContext, buttonKey },
  isBeforeAction,
) => {
  let alert = objectPath.get(action, 'alert') || {}
  Swal.fire({
    title: alert.title,
    text: alert.text,
    icon: alert.icon,
    confirmButtonText: alert.confirmButtonText,
    confirmButtonColor: alert.confirmButtonColor,
    showCancelButton: alert.showCancelButton,
    cancelButtonText: alert.cancelButtonText,
    cancelButtonColor: alert.cancelButtonColor,
    showCloseButton: alert.showCloseButton,
    showDenyButton: alert.showDenyButton,
    denyButtonText: alert.denyButtonText,
    denyButtonColor: alert.denyButtonColor,
    reverseButtons: alert.reverseButtons,
  }).then((result) => {
    if (result.isConfirmed) {
      if (alert.confirmAlert) {
        Swal.fire(alert.confirmTitle, alert.confirmText, 'success')
      }
      if (isBeforeAction) {
        onCheckCondition(designContext, formData, buttonKey, {
          isDebounce: false,
        })
        doAction()
      }
    } else if (result.isDenied) {
      if (alert.denyAlert) {
        Swal.fire(alert.denyTitle, alert.denyText, 'info')
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      if (alert.cancelAlert) {
        Swal.fire(alert.cancelTitle, alert.cancelText, 'error')
      }
    }
  })
}

export const callbackFunction = async ({ action, data, designContext }) => {
  let { formData } = data
  const { callback } = designContext
  let { callbackName } = action
  if (callbackName) {
    const onCallFunction = objectPath.get(callback, callbackName)
    if (onCallFunction) {
      let response = await onCallFunction()
      if (response) {
        return response
      }
    }
  }
  return {
    status: 200,
    message: '',
    data: formData,
  }
}

const getResetAuth = (jsonForm = {}, designContext = {}) => {
  return designContext.auth || { config: jsonForm.accountConfig || [] }
}

const findResetUiByKey = (key, elements = []) => {
  let foundUi
  elements.forEach((ui) => {
    if (foundUi) return
    if (ui?.key === key || ui?.name === key) {
      foundUi = ui
      return
    }
    if (ui?.input?.key === key || ui?.input?.name === key) {
      foundUi = ui.input
      return
    }
    let option = (ui?.options || []).find((option) => {
      return (
        option?.key === key ||
        option?.name === key ||
        option?.input?.key === key ||
        option?.input?.name === key
      )
    })
    if (option) {
      foundUi = [option?.key, option?.name].includes(key)
        ? option
        : option.input
      return
    }
    foundUi = findResetUiByKey(key, ui?.elements || [])
  })
  return foundUi
}

const getResetUi = (key, jsonForm = {}) => {
  let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
  if (ui?.key === key || ui?.name === key) return ui
  return findResetUiByKey(key, jsonForm?.uischema?.elements || [])
}

const setResetKey = (keyList = {}, key) => {
  if (key) keyList[key] = true
}

const createResetValueKeyList = (valueKey = {}, keyList = {}) => {
  Object.keys(valueKey || {}).forEach((key) => {
    let value = valueKey[key]
    if (typeof value === 'string') {
      setResetKey(keyList, value)
    }
  })
}

const createResetOtherValueList = (otherValues = {}, keyList = {}) => {
  Object.keys(otherValues || {}).forEach((key) => {
    let field = otherValues[key]?.field
    setResetKey(keyList, field)
  })
}

const createResetMappedKeyList = (ui = {}, keyList = {}) => {
  let optionTypes = [
    ui.optionType,
    'internal',
    'external',
    'custom',
    'array',
    'core',
    'jsonField',
  ].filter((type, index, list) => type && list.indexOf(type) === index)

  createResetOtherValueList(ui.otherValues, keyList)
  optionTypes.forEach((optionType) => {
    let optionConfig = ui[optionType] || {}
    createResetValueKeyList(optionConfig.valueKey, keyList)
    createResetOtherValueList(optionConfig.otherValues, keyList)
  })
}

const createResetKeyList = (elements = [], keyList = {}) => {
  elements.forEach((ui) => {
    if (!ui) return
    setResetKey(keyList, ui.key)
    setResetKey(keyList, ui.name)
    setResetKey(keyList, ui?.input?.key)
    setResetKey(keyList, ui?.input?.name)
    createResetMappedKeyList(ui, keyList)
    createResetMappedKeyList(ui?.input, keyList)
    let options = ui.options || []
    options.forEach((option) => {
      setResetKey(keyList, option?.key)
      setResetKey(keyList, option?.name)
      setResetKey(keyList, option?.input?.key)
      setResetKey(keyList, option?.input?.name)
      createResetMappedKeyList(option, keyList)
      createResetMappedKeyList(option?.input, keyList)
    })
    createResetKeyList(ui.elements || [], keyList)
  })
  return keyList
}

export const getResetKeyList = (jsonForm = {}) => {
  return {
    ...createResetKeyList(jsonForm?.uischema?.elements || []),
    ...jsonForm?.schema?.mapFormData,
    ...jsonForm?.schema?.mapKey,
  }
}

const setDefaultValue = ({ key, ui, formData, jsonForm, designContext }) => {
  if (!ui?.key) return
  let defaultUi = ui
  if (
    !defaultUi.tagname &&
    (objectPath.has(defaultUi, 'defaultChecked') ||
      objectPath.has(defaultUi, 'valueChecked') ||
      objectPath.has(defaultUi, 'valueUnchecked'))
  ) {
    defaultUi = { ...defaultUi, tagname: 'checkbox' }
  }
  let defaultValue = getDefaultValueFromUi(
    defaultUi,
    key,
    jsonForm,
    getResetAuth(jsonForm, designContext),
  )
  if (defaultValue === undefined) return
  objectPath.set(formData, key, cloneDeep(defaultValue))
  if (ui.name && ui.name !== key) {
    objectPath.set(formData, ui.name, cloneDeep(defaultValue))
  }
}

const deleteStorageValue = (jsonForm = {}, key, ui = {}) => {
  let { formCode } = jsonForm
  if (!formCode) return
  let storages = [
    typeof sessionStorage !== 'undefined' ? sessionStorage : null,
    typeof localStorage !== 'undefined' ? localStorage : null,
  ]
  storages.forEach((storage) => {
    if (!storage) return
    try {
      let storageJson = JSON.parse(storage.getItem(formCode)) || {}
      objectPath.del(storageJson, key)
      if (ui.name) objectPath.del(storageJson, ui.name)
      if (Object.keys(storageJson).length > 0) {
        storage.setItem(formCode, JSON.stringify(storageJson))
      } else {
        storage.removeItem(formCode)
      }
    } catch (error) {
      storage.removeItem(formCode)
    }
  })
}

export const clearFormStorage = (jsonForm = {}) => {
  let { formCode } = jsonForm
  if (!formCode) return
  let storages = [
    typeof sessionStorage !== 'undefined' ? sessionStorage : null,
    typeof localStorage !== 'undefined' ? localStorage : null,
  ]
  storages.forEach((storage) => {
    if (!storage) return
    storage.removeItem(formCode)
  })
}

const deleteObjectValueByPath = (data = {}, key = '') => {
  if (!key || !data || typeof data !== 'object') return

  if (Array.isArray(data)) {
    data.forEach((item) => deleteObjectValueByPath(item, key))
    return
  }

  objectPath.del(data, key)
  if (!String(key).includes('.')) {
    objectPath.del(data, [key])
  }
  Object.keys(data).forEach((dataKey) => {
    deleteObjectValueByPath(data[dataKey], key)
  })
}

const clearResetResponseValue = (formData = {}, key = '') => {
  if (!key) return

  objectPath.del(formData, ['@mapResponse', key])
  objectPath.del(formData, ['@response', key])

  let responseData = objectPath.get(formData, '@response') || {}
  Object.keys(responseData).forEach((apiKey) => {
    let response = objectPath.get(responseData, apiKey)
    deleteObjectValueByPath(response, key)
    deleteObjectValueByPath(objectPath.get(response, 'data'), key)
  })
}

export const resetKey = ({ keyList, formData = {}, designContext }) => {
  const {
    jsonForm,
    searchData = {},
    setFormData,
    setSearchData,
    isUiChanged,
    setIsUiChanged,
  } = designContext
  const mapWidgetUi = objectPath.get(jsonForm, 'schema.mapWidget.ui') || {}
  Object.keys(keyList).forEach((key) => {
    if (!key) return
    let ui = getResetUi(key, jsonForm)
    clearResetResponseValue(formData, key)
    clearResetResponseValue(searchData, key)
    objectPath.del(formData, key)
    objectPath.del(searchData, key)
    deleteStorageValue(jsonForm, key, ui)
    if (ui?.key === key || ui?.name === key) {
      clearResetResponseValue(formData, ui.key)
      clearResetResponseValue(searchData, ui.key)
      objectPath.del(formData, ui.key)
      objectPath.del(searchData, ui.key)
      if (ui.name) {
        clearResetResponseValue(formData, ui.name)
        clearResetResponseValue(searchData, ui.name)
        objectPath.del(formData, ui.name)
        objectPath.del(searchData, ui.name)
      }
      setDefaultValue({ key: ui.key, ui, formData, jsonForm, designContext })
      objectPath.set(isUiChanged, ['isResetField', ui.key], true)
    } else if (mapWidgetUi[key]) {
      let { name } = mapWidgetUi[key]
      clearResetResponseValue(formData, name)
      clearResetResponseValue(searchData, name)
      objectPath.del(formData, name)
    }
  })

  objectPath.set(jsonForm, 'formData', formData)
  setIsUiChanged({ ...isUiChanged })
  setFormData({ ...formData })
  setSearchData({ ...searchData })
  return formData
}

export const resetData = ({ action, data, designContext }) => {
  let { formData } = data
  const {
    jsonForm,
    setDesignerPropsData,
    setSearchData,
    isUiChanged,
    setIsUiChanged,
    setAllData,
    setDatasourceValue,
    setIsResetData,
  } = designContext
  const allFormGroup = getFormGroup(designContext)
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}

  let resetType = action?.resetType
  if (resetType === 'all') {
    cancelDesignerRequests()
    formData = resetKey({
      keyList: getResetKeyList(jsonForm),
      formData: {},
      designContext,
    })
    clearFormStorage(jsonForm)
    objectPath.set(designerPropsData, `data`, {})
    objectPath.set(designerPropsData, `isReset`, true)
    setDesignerPropsData(designerPropsData)
    setSearchData({})
    setAllData && setAllData({})
    setDatasourceValue && setDatasourceValue({})
    objectPath.set(isUiChanged, 'autocompleteOption', {})
    objectPath.set(isUiChanged, 'callAPI', {})
    objectPath.set(isUiChanged, 'isCheckingCondition', '')
    objectPath.set(isUiChanged, 'isResetAll', true)
    setIsUiChanged(isUiChanged)
    setIsResetData && setIsResetData(true)
  } else if (resetType === 'form') {
    let formList = action?.form || []
    formList.forEach((formKey) => {
      let form = allFormGroup.find(({ key }) => key === formKey) || {}
      let {
        isGroup,
        groupData = [],
        mapParam = {},
        mapArray = {},
      } = form
      let paramList = Object.keys(mapParam)

      paramList.forEach((key) => {
        let isArray = objectPath.get(mapArray, key)
        if (isArray) {
          let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
          if (ui.key === key) {
            let { elements = [] } = ui
            elements.forEach((mainElement) => {
              let name = mainElement.name
              if (mainElement.tagname === 'panel') {
                name = '@' + name
              }
              objectPath.del(formData, name)
              objectPath.del(formData, `@isCheckedAll.${name}`)
            })
          }
        }
      })
      if (isGroup) {
        groupData.forEach((group) => {
          formData = resetKey({
            keyList: getFormGroupResetKeyList(group),
            formData,
            designContext,
          })
        })
      } else {
        formData = resetKey({
          keyList: getFormGroupResetKeyList(form),
          formData,
          designContext,
        })
      }
    })
  }
  return {
    status: 200,
    message: '',
    formData,
  }
}

export const focusInput = ({ action, data }) => {
  let { formData } = data
  const { focusInput } = action
  if (focusInput) {
    let { key } = focusInput
    let input = document.getElementById(key)
    if (input) {
      input.focus()
    }
  }
  return {
    status: 200,
    message: '',
    data: formData,
  }
}
